import { ROUTES, TITLES, PROD, DEV, STAGE } from 'consts';

export const SETTING_MENU = {
  key: ROUTES.SETTING.ROOT,
  label: TITLES[ROUTES.SETTING.ROOT],
  environment: [DEV, STAGE, PROD],
  children: [
    {
      key: ROUTES.SETTING.APARTMENTS,
      label: TITLES[ROUTES.SETTING.APARTMENTS],
      environment: [DEV, STAGE, PROD],
    },
    {
      key: ROUTES.SETTING.ENG_NET,
      label: TITLES[ROUTES.SETTING.ENG_NET],
      environment: [DEV, STAGE, PROD],
      children: [
        {
          key: ROUTES.SETTING.ENG_NET_BY_PROJECT,
          label: TITLES[ROUTES.SETTING.ENG_NET_BY_PROJECT],
          environment: [DEV, STAGE, PROD],
        },
        {
          key: ROUTES.SETTING.ENG_NET_BY_OBJECT,
          label: TITLES[ROUTES.SETTING.ENG_NET_BY_OBJECT],
          environment: [DEV, STAGE, PROD],
        },
      ],
    },
  ],
};
